define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'model/Error',
	'view/canvas/ArrowButtonCanvas',
	'amdi18n-loader?!view/nls/ErrorView_strings',
	'lib/jquery'
], function (
	Logger,
	Util,
	UiUtil,
	Error,
	ArrowButtonCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * ErrorView class
	 */
	return function () {
		var _arrowButton = new ArrowButtonCanvas(),
			_view;

		_view = (function () {
			var content = jQuery(
				'<div id="skIdS_error-container" class="alert alert-warning">' +
					'<span id="skIdS_error-header"></span>' +
					'<div>' +
						'<hr class="skIdS_error-content-delimiter">' +
						'<p id="skIdS_error-content"></p>' +
					'</div>' +
				'</div>');

			return content;
		})();


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (error) {
			var $header = _view.find('#skIdS_error-header'),
				$content = _view.find('#skIdS_error-content');

			$header.empty();
			$content.empty();

			$header.append(Strings.sessionTimeout_title);
			$content.append(Strings.sessionTimeout_desc);

		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/TimeoutErrorView.js
// module id = 162
// module chunks = 1